<script setup lang="ts">
import AppButton from '@/application/components/ui/AppButton.vue';
import { ElAlert } from 'element-plus';
import { useVirtualList } from '@vueuse/core';
import { useContractStore } from "@/contracts/stores/contractStore";
import { spartenMapper } from "@/application/utils/sparteFormatter";
import { storeToRefs } from "pinia";
import { toRef } from "vue";

interface Props {
  modelValue: number[],
}

const props = defineProps<Props>();
const emit = defineEmits(['showSelectContracts'])

const { contractsMap } = storeToRefs(useContractStore());

// The row height is set on both the list and the item: `useVirtualList` uses it to
// compute scroll height, so the item has to match it.
const ITEM_HEIGHT = 32;

const { list, containerProps, wrapperProps } = useVirtualList(
  toRef(() => props.modelValue),
  { itemHeight: ITEM_HEIGHT },
);
</script>

<template>
  <div class="flex flex-col gap-2">
    <div class="flex flex-col md:flex-row items-start justify-between">
      <span class="font-medium text-gray-700 mb-1">Verträge</span>
      <div class="flex flex-col">
        <div
          v-bind="containerProps"
          class="w-80 max-h-40 md:max-h-48"
        >
          <div v-bind="wrapperProps" class="space-y-1">
            <div
              v-for="{ data: contractId } in list"
              :key="contractId"
              class="flex flex-row gap-2 items-start text-start text-xs"
              :style="{ height: `${ITEM_HEIGHT}px` }"
            >
              <span class="text-xs truncate bg-gray-100 rounded-full py-1 px-3 border-gray-200">
                {{ `${spartenMapper(contractsMap.get(contractId)?.product!)} (Nr.: ${contractsMap.get(contractId)?.number ?? '-'})` }}
              </span>
            </div>
          </div>
        </div>


        <div class="flex flex-row w-full md:w-80 ml-auto">
          <AppButton
            v-if="contractsMap.size > 0"
            type="primary"
            text
            bg
            class="mr-auto"
            :aria-label="modelValue && modelValue.length > 0 ? 'Verträge bearbeiten' : 'Auswählen'"
            @click="emit('showSelectContracts')"
          >
            {{ modelValue && modelValue.length > 0 ? 'Verträge bearbeiten' : 'Auswählen' }}
          </AppButton>
          <span v-else>Noch keine Verträge vorhanden.</span>
        </div>
      </div>
    </div>
    <ElAlert
      type="info"
      title="Vertragszuordnung"
      class="mt-3 text-start el-alert--primary"
      show-icon
    >
      Durch Zuordnung eines Vertrags zur Bankverbindung, wird dieses
      Konto für die Abbuchung der Versicherungsbeiträge genutzt.
    </ElAlert>
  </div>
</template>
